module.exports = __webpack_public_path__ + "img/Layout.2c6ba7ec.svg";